// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '../static/config.js'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import { store } from './store/store'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueCarousel from 'vue-carousel'
import Meta from 'vue-meta'
import lineClamp from 'vue-line-clamp'

Vue.use(Meta, {
  tagIDKeyName: 'vmid'
})

Vue.use(lineClamp, {
  // plugin options
})

Vue.use(BootstrapVue)
Vue.use(VueCarousel)

Vue.config.productionTip = false

/* eslint-disable no-undef */
export const global = {
  gaEvent: (event, category, label) => {
    if (label) {
      gtag('event', event, {'event_category': category, 'event_label': label})
    } else {
      gtag('event', event, {'event_category': category})
    }
  }
}
/* eslint-enable noundef */
Vue.prototype.$global = global

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js